declare module '@mui/system' {
  interface Shape {
    borderRadius: number;
    borderRadiusSm: number;
    borderRadiusMd: number;
  }
}

const shape = {
  borderRadius: 4,
  borderRadiusSm: 4,
  borderRadiusMd: 4,
};

export default shape;
